import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import {  makeStyles } from "@material-ui/core/styles";
import { Button, DialogActions, Dialog, Modal } from "@material-ui/core";
import { green } from "@material-ui/core/colors";

import DialpadIcon from '@material-ui/icons/Call';

import Dialpad from "./DialPad";

//store
import * as actions from "../../../../store/actions/actionIndex";
import CallModal from "../../../../helpers/CallModal";

const useStyles = makeStyles((theme) => ({

	selectInput: {
		padding: 10,
		paddingInlineEnd: 25,
		"&:focus": {
			backgroundColor: "white",
		},
	},
	title: {
		display: "block",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		width: "100%",
		marginBottom: theme.spacing(1),
	},
	fab: {
		position: "absolute",
		//bottom: theme.spacing(2),
		top: theme.spacing(8),
		insetInlineEnd: theme.spacing(2),
	},
	fabGreen: {
		color: theme.palette.common.white,
		backgroundColor: green[500],
		"&:hover": {
			backgroundColor: green[600],
		},
	},
	AutoModeButton: {
		margin: "14px 0",
		textAlign: "end",
		display: "flex",
		justifyContent: "space-between",
	},
	ConferenceButton: {
		height: "36px",
		color: "#526FEB",
		"&:hover": {
			backgroundColor: "#526FEB",
			color: "white",
		},
	},
	callDialog: {
		//position:"fixed",
		insetInlineEnd: "50px",
	},
	DispositionTitle: {
		color: "white",
		backgroundColor: "#242a5a",
		fontSize: "15px",
		lineHeight: "18px",
		marginBottom: -1,
		padding: "16px 25px 16px 24px",
		minHeight: 40,
		"&$expanded": {
			minHeight: 40,
		},
	},
}));


function PreviewModeTab(props) {
	const classes = useStyles();

	const { agentConf } = props;
	const [open, setOpen] = useState(false);
	const [ModalOpen, setModalOpen] = useState(false)
	const [previewDialing, setPreviewDialing] = useState(0);

	const handleClickOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};
	const handleModalClose = () =>{
		setModalOpen(false)
	}

	useEffect(() =>{
	if (open && props.agentState !== "FREE") {
			setModalOpen(false);
		}
   else{
	if(props.facilityConf.manual_dial_lookup === "1" && props.leads && props.leads.length>0){
		setModalOpen(true)
		setOpen(false)
	   }
   }
	},[props.leads, props.agentState])

	useEffect(() => {
		if (props.agentState === "FREE") {
		  setModalOpen(false);
		}
	  }, [props.agentState]);
	useEffect(() => {
		if (open && props.agentState !== "FREE") {
			setOpen(false);
		}
	}, [props.agentState, open, setOpen]);

	useEffect(() => {
		try {
			setPreviewDialing(agentConf.previewDialing === "ENABLED" && agentConf.saveInPreview === "1" ? 1 : 0);
		} catch (e) {}
	}, [agentConf, setPreviewDialing]);

// create a global variable for getting the data in dailing pad
	window.dialogState = {open:true}

	useEffect(() => {
	  const handleDialogChange = () => {
		if (window.dialogState && window.dialogState.open === false) {
		  handleClose();
		}
	  };
	
	  window.addEventListener("dialogStateChanged", handleDialogChange);
	  return () => window.removeEventListener("dialogStateChanged", handleDialogChange);
	}, [handleClose]);
	return (
		<div>
            {previewDialing ? (
		    <Button
                variant="outlined"
                color="primary"
                size="small"
                style={{
                    textTransform: "capitalize",
                    border: "2px solid",
                    marginInlineStart: "0",
                    marginInlineEnd: "10px",
                }}
                onClick={handleClickOpen}
                className={classes.ConferenceButton}
            >
                Dial
            </Button>
        
			) : (
				""
			)}
			<Dialog open={open} style={{ position: "absolute"}} onClose={handleClose} aria-labelledby="form-dialog-title">
				<DialogActions className={classes.callDialog} style={{ padding: "0px" }}>
					<Dialpad handleClose={handleClose} />
				</DialogActions>
			</Dialog>
			<Modal open = {ModalOpen} onClose={handleModalClose}    aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description" >
		<CallModal onClose={handleModalClose}  />
	  </Modal>
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		agentId: state.agentData.agentId,
		agentConf: state.agentConfig.agentConf,
		agentMode: state.agentData.dialerType,
		autoMode: state.agentData.autoMode,
		leads: state.manualData.leads,
		agentState: state.agentData.agentState,
		modeError: state.agentMode.error,
		modeLoading: state.agentMode.loading,
		facilityConf: state.agentConfig.facilityConf,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		 onManualData: (agentId, phoneNo) =>
			dispatch(actions.manualData(agentId, phoneNo )),
		onModeChange: (agentId, mode, agentState) => dispatch(actions.modeChange(agentId, mode, agentState)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewModeTab);
